// Keep affiliate destinations intact: do not re-encode signed or nested URL parameters.
export function affiliateLink(link, placement, parameter) {
  if (typeof link !== "string" || typeof parameter !== "string" ||
      typeof placement !== "string" || !parameter.trim() || !placement.trim() ||
      /^(undefined|null)$/i.test(parameter.trim()) || /^(undefined|null)$/i.test(placement.trim())) return link;
  try {
    const url = new URL(link, "https://www.thehoopsgeek.com");
    if (!/^https?:$/.test(url.protocol)) return link;
    const hashIndex = link.indexOf("#");
    const hash = hashIndex < 0 ? "" : link.slice(hashIndex);
    const base = hashIndex < 0 ? link : link.slice(0, hashIndex);
    const queryIndex = base.indexOf("?");
    const path = queryIndex < 0 ? base : base.slice(0, queryIndex);
    const query = queryIndex < 0 ? "" : base.slice(queryIndex + 1);
    const key = parameter.trim();
    const parts = query.split("&").filter(part => {
      if (!part) return false;
      try { return decodeURIComponent(part.split("=")[0].replace(/\+/g, " ")) !== key; }
      catch (_) { return true; }
    });
    parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(placement.trim()));
    return path + "?" + parts.join("&") + hash;
  } catch (_) { return link; }
}

function numberOrUndefined(value) {
  if (value == null || value === "") return undefined;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : undefined;
}

export function affiliateData({ shop, price, listPrice, product, brand, styleId, styleName, resale = false }) {
  const amount = numberOrUndefined(price);
  const list = numberOrUndefined(listPrice);
  return {
    "data-shop": shop,
    "data-price": amount,
    "data-list-price": list,
    "data-discount": !resale && amount !== undefined && list > 0
      ? Math.round((1 - amount / list) * 100) : undefined,
    "data-product": product,
    "data-brand": brand,
    "data-style-id": styleId,
    "data-style-name": styleName,
  };
}

export function shoeAffiliateData(shoe, type = "new") {
  const resale = type === "resell";
  const offer = (resale ? shoe.resell_offer : shoe.new_offer) || {};
  return affiliateData({ shop: offer.shop_name, price: resale ? shoe.resell_price : shoe.discount,
    listPrice: shoe.price, product: shoe.shoe_name, brand: shoe.brand, resale });
}

// GTM owns affiliate_click and GA4 enhanced measurement owns page_view.
// Send only app interactions here, through the same dataLayer as GTM-TNCTCWR.
// The legacy global gtag() uses a separate, unconsumed gTagDataLayer on the site.
export function trackGA4(event, properties = {}) {
  if (typeof window === "undefined" ||
      !/^(www\.)?thehoopsgeek\.com$/.test(window.location?.hostname || "") ||
      event === "affiliate_click" || event === "page_view" ||
      !/^[a-zA-Z][a-zA-Z0-9_]{0,39}$/.test(event)) return false;
  try {
    const layer = window.dataLayer;
    if (!layer || typeof layer.push !== "function") return false;
    const params = { ...properties, send_to: "G-96G20XQT03" };
    // Google's command queue consumes Arguments objects, not custom GTM events.
    (function () { layer.push(arguments); })("event", event, params);
    return true;
  } catch (_) { return false; }
}

export function trackInteraction(category, action, label) {
  if (typeof action !== "string" || action.toLowerCase() === "affiliate click") return false;
  const event = action.toLowerCase().replace(/[^a-z0-9_]+/g, "_").replace(/^_+|_+$/g, "").slice(0, 40);
  const params = { event_category: category };
  if (typeof label === "string" || typeof label === "number") params.event_label = label;
  return trackGA4(event, params);
}
